/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { cn } from "tailwind-variants";
import "./EnhancementTierLabel.scss";

export default function EnhancementTierLabel({ tier, ...restProps }: any) {
  function icon() {
    if (tier === "print_original") return "printer";
    if (tier === "custom") return "stars-4";
    if (tier === "full_enhancements") return "stars";
    if (tier === "basic") return "star-4";
    return "";
  }

  function label() {
    if (tier === "print_original") return "Print As Is";
    if (tier === "custom") return "Expert Edit";
    if (tier === "full_enhancements") return "PrintPerfect";
    if (tier === "basic") return "Basic";
    return "";
  }

  return (
    <div
      {...restProps}
      className={cn("enhancement-tier-label scope-067b0cec", restProps.className)}
    >
      <UseSvg
        className="enhancement-tier-label__icon scope-067b0cec"
        icon={icon()}
        data-testid="enhancement-tier-label-icon"
      />{" "}
      {label()}
    </div>
  );
}
